import loadReduxAction from 'modules/redux/actions/load'
import {
  WORKOUTS_ENDPOINT,
  WORKOUTS_PATH
} from 'modules/workout/redux/constants'
import getEndpointTrainingUtil from 'modules/training/utils/get-endpoint'
import { logUtil } from 'packages/src'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import getDomainListPathFromQueryReduxUtil from 'modules/redux/utils/get-domain-list-path-from-query'
import { WORKOUTS_ACTION } from '@gymaholic/packages'
import getTagWorkoutsSelect from 'modules/workout/redux/selectors/get-tag/index.js'
import getDomainListPathFromTagReduxUtil from 'modules/redux/utils/get-domain-list-path-from-tag/index.js'
import getTagFromMatchRouteUtil from 'modules/routes/utils/get-tag-from-match/index.js'
import { getPaginationLimitAppSelect } from 'modules/app/selectors/getPaginationLimit/index.js'

/**
 * @param options
 * @param match
 * @param ignoreTag
 * @param queryParams
 * @returns {(function(*, *): Promise<void>)|*}
 */
function loadRecommendedWorkoutsAction ({
  options,
  match,
  ignoreTag,
  queryParams = {}
} = {}) {
  return async (dispatch, getState) => {
    try {
      const query = getQuerySearchSelect(getState())
      const tag = (
        getTagWorkoutsSelect(getState()) ||
        getTagFromMatchRouteUtil(match)
      )
      const debugProps = {
        query,
        tag
      }
      logUtil('loadRecommendedWorkoutsAction').debug('[start] debugProps=', debugProps)

      if (!queryParams.limit) {
        queryParams.limit = getPaginationLimitAppSelect(getState())
      }

      let domainListPath = WORKOUTS_PATH.RECOMMENDED
      if (query) {
        queryParams.q = query
        domainListPath = getDomainListPathFromQueryReduxUtil(domainListPath, query)
      }

      if (!ignoreTag) {
        queryParams.tag = tag
        domainListPath = getDomainListPathFromTagReduxUtil(domainListPath, tag)
      }

      const endpoint = getEndpointTrainingUtil(
        WORKOUTS_ENDPOINT.LOAD_RECOMMENDED,
        queryParams
      )

      await dispatch(
        loadReduxAction({
          type: WORKOUTS_ACTION.LOAD_RECOMMENDED,
          payload: {
            endpoint,
            domainListPath
          },
          options
        })
      )
    } catch (error) {
      logUtil('loadRecommendedWorkoutsAction').error('error=', error)
    }
  }
}

export default loadRecommendedWorkoutsAction
